import * as React from 'react';
import { useLocation } from 'react-router-dom';
import utils from '@/utils/utils';
import { isMenuGray } from '@/utils/url';
import { cachedResources } from '@/config';

function V3Vue() {
    const { pathname } = useLocation();
    const _path = pathname.split('/').slice(3).join('/');
    if (isMenuGray) {
        // mange 路由菜单中增加 add
        const PATH_ADD = 'add';
        const RESOURCE_MANAGE = 'manage';
        if (
            _path === PATH_ADD &&
            !cachedResources?.includes(RESOURCE_MANAGE) &&
            !cachedResources?.includes(_path)
        ) {
            return <></>;
        }
    }
    const params = utils.urlParse();
    const paramsStr = Object.entries(params)
        .map(([k, v]) => `${k}=${encodeURIComponent(v)}`)
        .join('&');

    const getSrc = () => {
        if (isMenuGray) {
            const src =
                process.env.NODE_ENV === 'development'
                    ? `http://127.0.0.1:5000?v=${Date.now()}#/main/${_path}`
                    : `${window.location.origin}/v3/vue?v=${Date.now()}#/main/${_path}`;
            return src;
        } else {
            const src =
                process.env.NODE_ENV === 'development'
                    ? `http://127.0.0.1:5000#/main/${_path}`
                    : `${window.location.origin}/v3/vue#/main/${_path}`;
            return src;
        }
    };
    return (
        <div className="main-content">
            <iframe src={`${getSrc()}?${paramsStr}`} frameBorder="no" width="100%" height="100%" />
        </div>
    );
}

export default V3Vue;
